import { tv } from "tailwind-variants";

export const select = tv({});

export const control = tv({
    base: [
        "tw:px-3 tw:w-full tw:h-12! tw:min-h-auto! tw:gap-5! tw:flex! tw:bg-white tw:border! tw:border-grey-input tw:transition-shadow!",
        "tw:focus-within:z-20!"
    ],
    variants: {
        isFocused: {
            true: "tw:ring-inset! tw:ring-3! tw:ring-primary/40! tw:border-primary!"
        },
        isInvalid: {
            true: "tw:border-danger! tw:ring-danger/40!"
        },
        isValid: {
            true: "tw:border-success! tw:ring-success/40!"
        }
    }
});

export const container = tv({
    base: [
        "tw:rounded-md",
        "tw:group-[*]/inputgroup:not-first:*:rounded-l-none!",
        "tw:group-[*]/inputgroup:not-last:*:rounded-r-none!",
        "tw:group-[*]/inputgroup:not-last:*:-mr-px!"
    ]
});

export const valueContainer = tv({
    base: ["tw:pr-0!"]
});

export const clearIndicator = tv({
    base: ["tw:pl-0!"]
});

export const loadingIndicator = tv({
    base: ["tw:pl-0!"]
});

export const dropdownIndicator = tv({
    base: ["tw:pl-0!"]
});

export const indicatorSeparator = tv({
    base: ["tw:mx-5"]
});

export const option = tv({
    base: ["tw:pl-5! tw:pr-5!"],
    variants: {
        isSelected: {
            true: "tw:bg-primary/30! tw:text-black!"
        },
        isFocused: {
            true: "tw:bg-primary/10! tw:text-black!"
        }
    }
});

export const menuList = tv({
    base: ["tw:py-0!"]
});
